import PropTypes from 'prop-types';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function RelationPreview({
  value
}) {
  return _jsx(WidgetPreviewContainer, {
    children: value
  });
}
RelationPreview.propTypes = {
  value: PropTypes.node
};
export default RelationPreview;